// viewers/UnknownViewer.tsx
export default function UnknownViewer() {
  return <div className="text-center text-gray-500 p-4">Unsupported file type.</div>;
}
